<template>
  <div>视频会议</div>
</template>

<script>
export default {};
</script>